export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk-bets.vue?vue&type=template&id=1abb136e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/bk-bets.vue?vue&type=template&id=1abb136e&scoped=true
// module id = +1m+
// module chunks = 0